import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../../../core/user/user.service";

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit {

    constructor(
        private router: Router,
        private _userService: UserService
    ) {
    }

    ngOnInit(): void {
        this.router.navigate([this._userService.fetchDefaultRoute()]);
    }

}
